import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { DriverPrivilegeBadge } from '../models/privilege/driver-privilege-badge.model';
import { map } from 'rxjs/operators';
import { DriverSORPointer } from '../models/privilege/driver-sor-pointer.model';
import { DriverRestrictedPrivilegeDates } from '../models/privilege/driver-restricted-privilege.model';
import { DriverPointers } from '../models/privilege/driver-pointers.model';
import { DriverRestrictedCredentialEligibility } from '../models/privilege/driver-restricted-credential-eligibility.model';

@Injectable()
export class DriverPrivilegeService extends BaseApiService {
    // TODO: This return type is a hack.  Need to get the Validation models in sync between the server and client
    // and then this can be changed to ValidationModel<Array<DriverPrivilegeBadge>>.
    public getCustomerBadge(customerNumberId: number, getPermits: boolean = false): Observable<{ result: DriverPrivilegeBadge[] }> {
        return this.get(`Driver/Privilege/Badge/${customerNumberId}/${getPermits}`);
    }

    public getSORPointers(customerNumberId: number): Observable<DriverSORPointer[]> {
        return this.get(`Driver/Privilege/SORPointers/${customerNumberId}`).pipe(map(p => p.result));
    }

    public getPointers(customerNumberId: number): Observable<DriverPointers> {
        return this.get(`Driver/Privilege/Pointers/${customerNumberId}`);
    }

    public getRestrictedPrivilege(customerNumberId: number): Observable<DriverRestrictedPrivilegeDates> {
        return this.get(`Driver/Privilege/Restricted/${customerNumberId}`).pipe(map(p => p.result));
    }

    public getIidDefermentEligibility(customerNumberId: number): Observable<boolean> {
        return this.get(`Prohibition/IidDefermentEligibility/${customerNumberId}`).pipe(map(p => p.result));
    }

    public getCustomerRestrictedCredentialEligibility(customerNumberId: number): Observable<DriverRestrictedCredentialEligibility> {
        return this.get(`Driver/Privilege/RestrictedEligibility/${customerNumberId}`).pipe(map(p => p.result));
    }
}
